import { Card } from '../../card/Card'
import { ComponentVersionsInherit } from '../../context/ComponentVersionsContext'
import { ComponentVersions_3_0 } from '../../context/constants'
import { Button } from '../../core/Button'
import { Icon } from '../../core/Icon'
import { Typography } from '../../core/Typography'
import { styled } from '../../styles'
import { BaseTheme } from '../../theme/BaseTheme'

const StyledCard = styled(Card)({
  padding: '16px 10px',
  backgroundColor: BaseTheme.palette.yellow[200],
  borderRadius: 8,
  textAlign: 'center',
  margin: '16px 0',
  border: `1px solid ${BaseTheme.palette.neutralGrey[500]}`,
})

const CardHeader = styled('div')(() => ({
  padding: '0 16px',
}))

const PoweredByContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '10px',
  gap: 8,
}))

const ButtonWrapper = styled('div')({
  padding: '12px 8px 8px',
})

export const CheckoutFinancingCard = (props: {
  onClick(): void
  hidden?: boolean
  translate: (text: string) => string
}) => {
  const { onClick, hidden, translate } = props
  const publicUrl = (window as Window & { PUBLIC_URL?: string }).PUBLIC_URL ?? ''

  if (hidden === true) return null

  return (
    <>
      <ComponentVersionsInherit versions={ComponentVersions_3_0}>
        <StyledCard elevation={0}>
          <CardHeader>
            <Typography textVariant="body1SemiBold">
              {translate('Looking to spread out the cost of your project?')}
            </Typography>
          </CardHeader>
          <ButtonWrapper>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              onClick={onClick}
              size="xSmall"
              endIcon={<Icon icon="open_in_new" />}
            >
              {translate('Explore Finance Options')}
            </Button>
          </ButtonWrapper>
          <PoweredByContainer>
            <Typography textVariant="body4">{translate('by')}</Typography>
            {/* SMP serves from spa/proposal/public — keep logo.svg in sync with spa/app/public/images */}
            <img src={`${publicUrl}/images/logo.svg`} alt={'OpenSolar Logo'} height={24} />
          </PoweredByContainer>
        </StyledCard>
      </ComponentVersionsInherit>
    </>
  )
}
